import { Box } from '@mui/material';
import ErmsContentComponents from 'components/MapView/RightBar/AnalyticsTab/ErmsContentComponents';
import { useState } from 'react';
import { GisAnalysisContent } from './GisAnalysisContent';

enum AnalyticModeEnum {
  ERMS = 'ERMS',
  GIS_ANALYSIS = 'GIS_ANALYSIS',
}

const AnalyticTabContent = () => {
  const [analyticMode, setAnalyticMode] = useState<AnalyticModeEnum>(AnalyticModeEnum.GIS_ANALYSIS);

  const listButtons = [
    { key: 1, value: AnalyticModeEnum.ERMS, label: 'ERMS' },
    { key: 2, value: AnalyticModeEnum.GIS_ANALYSIS, label: 'GIS Analysis' },
  ];

  const handleClickButton = (value: AnalyticModeEnum) => {
    setAnalyticMode(value);
  };

  const calculateVariant = (value: AnalyticModeEnum) => {
    if (analyticMode === value) return 'contained';
    return 'outlined';
  };

  return (
    <Box display="flex" flexDirection="column" gap="16px">
      {/* <ButtonGroup variant="outlined" aria-label="Basic button group">
        {listButtons.map((item) => (
          <Button variant={calculateVariant(item.value)} key={item.key} onClick={() => handleClickButton(item.value)}>
            {item.label}
          </Button>
        ))}
      </ButtonGroup> */}

      <Box>
        {analyticMode === AnalyticModeEnum.GIS_ANALYSIS && <GisAnalysisContent />}
        {analyticMode === AnalyticModeEnum.ERMS && <ErmsContentComponents />}
      </Box>
    </Box>
  );
};

export default AnalyticTabContent;
